import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M98.76 18.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M106.87 36.65l3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path
      fill="#D8FFFF"
      d="M37.56 114.36a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="M19.59 81.17h-5.57V75.6c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H5.45c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M17.53 111.86c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#0597A3"
      fillRule="evenodd"
      d="M44.34 78.53V20.14c0-.51.57-.82 1-.54l6.19 4.06c.23.15.52.14.74-.02l6.52-4.87a.63.63 0 0 1 .75-.01l7.3 5.05c.22.15.51.15.74 0l7.22-5.04a.66.66 0 0 1 .77.02l6.24 4.97c.22.18.53.19.76.03l6.17-4.18a.648.648 0 0 1 1.01.53v58.31c0 .53-.59.83-1.02.52l-5.86-4.21a.63.63 0 0 0-.74 0l-6.83 4.7c-.22.15-.51.15-.72 0l-6.99-4.71a.63.63 0 0 0-.72 0l-6.86 4.71c-.21.15-.49.15-.71.01l-7.02-4.44a.66.66 0 0 0-.69 0l-6.23 4.02a.64.64 0 0 1-.99-.54z"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M28.25 96.3V37.9c0-.51.57-.82 1-.54l6.19 4.06c.23.15.52.14.74-.02l6.52-4.87a.63.63 0 0 1 .75-.01l7.3 5.05c.22.15.51.15.74 0l7.22-5.04a.66.66 0 0 1 .77.02l6.24 4.97c.22.18.53.19.76.03l6.17-4.18a.648.648 0 0 1 1.01.53v58.31c0 .53-.59.83-1.02.52l-5.86-4.21a.63.63 0 0 0-.74 0l-6.83 4.7c-.22.15-.51.15-.72 0l-6.99-4.71a.63.63 0 0 0-.72 0l-6.86 4.71c-.21.15-.49.15-.71.01l-7.02-4.44a.66.66 0 0 0-.69 0l-6.23 4.02a.64.64 0 0 1-.99-.54z"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      d="M61.2 59.5H40.86c-1.24 0-2.25-1.01-2.25-2.25S39.62 55 40.86 55H61.2c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M61.2 69.61H40.86c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25H61.2c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M61.2 79.72H40.86c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25H61.2c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
  </svg>
);
const SvgEnrichedIconReceiptManagementBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconReceiptManagementBrand);
export default Memo;
